// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";

// Define a service using a base URL and expected endpoints
export const questionApi = createApi({
  reducerPath: "questionApi",
  baseQuery: encryptedBaseQueryWithReauth(),
  // baseQuery: fetchBaseQuery({
  //   baseUrl: process.env.REACT_APP_BASE_URL,
  //   prepareHeaders: (headers, { getState }) => {
  //     const token = localStorage.getItem("token");
  //     const uid = getState().users?.userInfo?._id;
  //     if (token) {
  //       headers.set("authorization", `Bearer ${token}`);
  //     }
  //     if (uid) headers.set("uid", uid);
  //     return headers;
  //   },

  // }),
  tagTypes: ["getQuestionList", "questionDetail"],
  endpoints: (builder) => ({
    getQuestionList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getQuestionList"],
    }),

    getSingleQuestion: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["questionDetail"]
    }),
    getListData: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    getListTopicSubTopicData: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    getEntityList: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),

    deleteQuestion: builder.mutation({
      query: (endpoint) => ({
        url: `${endpoint}`,
        method: "DELETE",
      }),
      invalidatesTags: ["getQuestionList"],
    }),

    addQuestion: builder.mutation({
      query: ({ endpoint, newUser }) => ({
        url: endpoint,
        method: "POST",
        body: newUser,
        formData: true
      }),
      invalidatesTags: ["getQuestionList"],
    }),

    updateQuestion: builder.mutation({
      query: ({ endpoint, updateQuestion }) => ({
        url: endpoint,
        method: "PATCH",
        body: updateQuestion,
      }),
      invalidatesTags: ["questionDetail"],
    }),
    getQuestionsByEntityType: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,

      }),
      invalidatesTags: ["getQuestionList"],
    }),

    getSubjectList: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    getTopicList: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),

    getContentDeveloperQuestionList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getQuestionList"],
    }),

    addContentQuestion: builder.mutation({
      query: ({ endpoint, newUser }) => ({
        url: endpoint,
        method: "POST",
        body: newUser,
        formData: true
      }),
      invalidatesTags: ["getQuestionList"],
    }),
    markQuestion: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "PATCH",
        body: data,
        // formData: true
      }),
    }),
     movedToBankQuestion: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
        // formData: true
      }),
    }),
    publish: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,

        };
      },
    }),

  }),
});

export const {
  useGetQuestionListQuery,
  // useGetSubjectListQuery,
  useLazyGetSubjectListQuery,
  useLazyGetTopicListQuery,
  useLazyGetQuestionListQuery,
  useGetSingleQuestionQuery,
  useGetContentDeveloperQuestionListQuery,
  useDeleteQuestionMutation,
  useMovedToBankQuestionMutation,
  useAddQuestionMutation,
  useAddContentQuestionMutation,
  useMarkQuestionMutation,
  useUpdateQuestionMutation,
  usePublishMutation,
  useGetListDataQuery,
  useGetEntityListQuery,
  useGetQuestionsByEntityTypeMutation,
  useLazyGetListTopicSubTopicDataQuery

} = questionApi;
